import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from 'react-bootstrap';
import Cropper from 'react-cropper';
import Dropzone from 'react-dropzone';

import { StdModalDialog } from '../blocks/dialog';

import 'cropperjs/dist/cropper.css';
import { toast } from 'react-toastify';

export default class ImageLoader extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            imgDialogOpen: false, imagePreviewUrl: '', file: '', fileName: '', minSize: props.minSize || '0x0',
        };
        this.fileChangeHandler = this.fileChangeHandler.bind(this);
        this.saveImage = this.saveImage.bind(this);
        this.cropper = React.createRef();
    }

    openImgDialog = () => {
        const { image } = this.props;

        const url = image ? image.replace('media.vkplay.ru', window.location.hostname) : '';
        this.setState({ imagePreviewUrl: url, file: !!image, imgDialogOpen: true });
    };

    closeImgDialog = () => {
        this.setState({ imagePreviewUrl: '', file: '', imgDialogOpen: false });
    };

    fileChangeHandler(files) {
        const reader = new FileReader();
        reader.readAsDataURL(files[0]);
        reader.onloadend = () => {
            this.setState({
                imagePreviewUrl: reader.result,
            });
        };

        this.setState({ file: files[0], fileName: files[0].name });
    }

    handleRemove = () => {
        const { onRemove, name } = this.props;

        onRemove(name);
    };

    loadFileBody() {
        return (
            <div>
                <Dropzone
                    accept="image/jpeg, image/png"
                    onDrop={this.fileChangeHandler}

                >
                    {({ getRootProps, getInputProps }) => (
                        <div {...getRootProps()} className="dropzone" id="dropZone">
                            <input {...getInputProps()} />
                            <p>Перетащите файл в эту область</p>
                            <p>
                                Рекомендуемый размер - не менее
                                {this.state.minSize}
                                {' '}
                                пикселей.
                            </p>
                            <Button> Выбрать файл </Button>
                        </div>
                    )}
                </Dropzone>
            </div>
        );
    }

    cropHandler(event) {
        const minWidth = parseInt(this.state.minSize.split('x')[0]);
        const minHeight = parseInt(this.state.minSize.split('x')[1]);

        if ((event.detail.width < minWidth || event.detail.height < minHeight) && this.refs.cropper) {
            this.refs.cropper.cropper.setData(
                {
                    ...event.detail,
                    width:
                        event.detail.width < minWidth
                            ? minWidth
                            : event.detail.width,
                    height:
                        event.detail.height < minHeight
                            ? minHeight
                            : event.detail.height,
                },
            );
        }
    }

    editPicBody() {
        const minWidth = parseInt(this.state.minSize.split('x')[0]);
        const minHeight = parseInt(this.state.minSize.split('x')[1]);
        const img = new Image();
        img.src = this.state.imagePreviewUrl;
        img.onload = () => {
            if (img.width < minWidth || img.height < minHeight) {
                this.setState({ file: '', imagePreviewUrl: '' });
                toast.warn('Слишком маленькое изображение');
            }
        };

        return (

            <Cropper
                aspectRatio={minWidth / minHeight}
                viewMode={1}
                ref="cropper"
                src={this.state.imagePreviewUrl}
                guides={false}
                crop={this.cropHandler.bind(this)}
            />
        );
    }

    dialogFooter() {
        if (this.state.file) {
            return (
                <Button onClick={() => this.setState({ file: '' })}>
                    {' '}
                    <FontAwesomeIcon icon="redo" />
                    {' '}
                    Заменить изображение
                </Button>
            );
        }
    }

    dialogBody() {
        let body;

        if (!this.state.file) {
            body = this.loadFileBody();
        } else {
            body = this.editPicBody();
        }

        return body;
    }

    saveImage() {
        const result = this.refs.cropper.getCroppedCanvas().toDataURL(this.props.isPNG ? 'image/png' : 'image/jpeg', 0.75);
        this.closeImgDialog();
        this.props.onChange({
            target: { type: 'cropped_img', value: result, id: this.props.name, fileName: this.state.fileName },
            currentTarget: { type: 'cropped_img', value: result, id: this.props.name, fileName: this.state.fileName },
        });
    }

    render() {
        return (
            <div>
                <Button variant="outline-dark" onClick={this.openImgDialog}>Изменить</Button>
                {this.props.onRemove && !this.props.isDefault && (
                    <Button className="image-cover__reset" variant="outline-secondary" onClick={this.handleRemove}>Сбросить</Button>
                )}

                <StdModalDialog
                    isOpen={this.state.imgDialogOpen}
                    container={this}
                    hideHandler={this.closeImgDialog}
                    closeHandler={this.closeImgDialog}
                    title={this.props.title}
                    body={this.dialogBody()}
                    footer={this.dialogFooter()}
                    onSave={this.saveImage}
                />
            </div>
        );
    }
}
